export default  {
    install: (app) => {
        app.config.globalProperties.$isMobile = () => {
          return window.innerWidth <= 800;  
        };
    },
}
